/* eslint-disable @typescript-eslint/no-explicit-any */
import { append, addClass, remove, isNullOrUndefined, setStyleAttribute, createElement, prepend, removeClass } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import * as cls from '../base/css-constant';
import * as util from '../base/util';
/**
 * Virtual Scroll
 */
export class VirtualScroll {
    constructor(parent) {
        this.translateY = 0;
        this.itemSize = 60;
        this.bufferCount = 3;
        this.renderedLength = 0;
        this.averageRowHeight = 0;
        this.startIndex = 0;
        this.existingDataCollection = [];
        this.enableTransition = true;
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        if (!this.parent || this.parent && this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.virtualScroll, this.virtualScrolling, this);
    }
    removeEventListener() {
        if (!this.parent || this.parent && this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.virtualScroll, this.virtualScrolling);
    }
    getRenderedCount() {
        this.setItemSize();
        const containerSize = this.isHorizontalScroll ? this.parent.element.clientWidth : this.parent.element.clientHeight;
        this.renderedLength = Math.ceil(containerSize / this.itemSize) + this.bufferCount;
        return this.renderedLength;
    }
    renderVirtualTrack(contentWrap) {
        const wrap = createElement('div', { className: cls.VIRTUAL_TRACK_CLASS });
        if (this.isHorizontalScroll) {
            const colCount = this.parent.activeView.colLevels[this.parent.activeView.colLevels.length - 1].length;
            wrap.style.width = (colCount * this.itemSize) + 'px';
        }
        else {
            wrap.style.height = (this.parent.resourceBase.expandedResources.length * this.itemSize) + 'px';
        }
        contentWrap.appendChild(wrap);
    }
    updateVirtualScrollHeight() {
        const virtual = this.parent.element.querySelector('.' + cls.VIRTUAL_TRACK_CLASS);
        const lastResourceIndex = this.parent.resourceBase.expandedResources[this.parent.resourceBase.expandedResources.length - 1].groupIndex;
        const lastRenderIndex = this.parent.resourceBase.renderedResources[this.parent.resourceBase.renderedResources.length - 1].groupIndex;
        if (lastRenderIndex !== lastResourceIndex) {
            const conTable = this.parent.element.querySelector('.' + cls.CONTENT_TABLE_CLASS);
            this.renderedLength = conTable.querySelector('tbody').children.length;
            virtual.style.height = (conTable.offsetHeight + (this.parent.resourceBase.expandedResources.length - (this.renderedLength)) *
                conTable.offsetHeight / this.renderedLength) + 'px';
            const conWrap = this.parent.element.querySelector('.' + cls.CONTENT_WRAP_CLASS);
            if ((conWrap.scrollHeight - conWrap.scrollTop) < conWrap.offsetHeight * this.bufferCount) {
                virtual.style.height = parseInt(virtual.style.height, 10) + (conWrap.offsetHeight * this.bufferCount) + 'px';
            }
        }
        else {
            virtual.style.height = '';
        }
        this.averageRowHeight = virtual.offsetHeight / this.parent.resourceBase.expandedResources.length;
    }
    updateVirtualTrackHeight(wrap) {
        const resourceCount = this.parent.resourceBase.renderedResources.length;
        if (resourceCount !== this.getRenderedCount()) {
            wrap.style.height = this.parent.element.querySelector('.e-content-wrap').clientHeight + 'px';
            const resWrap = this.parent.element.querySelector('.' + cls.RESOURCE_COLUMN_WRAP_CLASS);
            const conWrap = this.parent.element.querySelector('.' + cls.CONTENT_WRAP_CLASS);
            const eventWrap = this.parent.element.querySelector('.' + cls.EVENT_TABLE_CLASS);
            this.translateY = 0;
            this.setTranslate(resWrap, conWrap, eventWrap);
        }
        else {
            const lastRenderIndex = this.parent.resourceBase.renderedResources[resourceCount - 1].groupIndex;
            const lastCollIndex = this.parent.resourceBase.expandedResources[this.parent.resourceBase.expandedResources.length - 1].groupIndex;
            let renderedResCount = resourceCount + (lastCollIndex - lastRenderIndex);
            renderedResCount = (renderedResCount > this.parent.resourceBase.expandedResources.length) ?
                this.parent.resourceBase.expandedResources.length : renderedResCount;
            wrap.style.height = (renderedResCount * this.itemSize) + 'px';
        }
    }
    setItemSize() {
        if (this.isHorizontalScroll) {
            this.itemSize = util.getElementWidthFromClass(this.parent.activeView.element, cls.WORK_CELLS_CLASS, this.parent.uiStateValues.isTransformed) || this.itemSize;
        }
        else {
            this.itemSize = this.parent.getElementHeightFromClass(this.parent.activeView.element, cls.WORK_CELLS_CLASS) || this.itemSize;
        }
    }
    refreshLayout() {
        const initialHeight = this.parent.uiStateValues.scheduleHeight;
        this.parent.uiStateValues.scheduleHeight = this.parent.element.offsetHeight;
        const preRenderedLength = this.renderedLength;
        if (this.parent.uiStateValues.scheduleHeight !== initialHeight) {
            if (preRenderedLength < this.getRenderedCount()) {
                this.isRemoteRefresh = true;
            }
            const resWrap = this.parent.element.querySelector('.' + cls.RESOURCE_COLUMN_WRAP_CLASS);
            const conWrap = this.parent.element.querySelector('.' + cls.CONTENT_WRAP_CLASS);
            const eventWrap = this.parent.element.querySelector('.' + cls.EVENT_TABLE_CLASS);
            if (!this.parent.rowAutoHeight) {
                this.enableTransition = false;
                removeClass([conWrap, resWrap], 'e-transition');
            }
            let firstTDIndex = parseInt(resWrap.querySelector('tbody td').getAttribute('data-group-index'), 10);
            const endIndex = (firstTDIndex + this.renderedLength);
            firstTDIndex = (endIndex > this.parent.resourceBase.expandedResources.length) ?
                (this.parent.resourceBase.expandedResources.length - this.renderedLength) : firstTDIndex;
            firstTDIndex = firstTDIndex < 0 ? 0 : firstTDIndex;
            this.existingDataCollection = this.parent.resourceBase.renderedResources;
            this.parent.resourceBase.renderedResources = this.parent.resourceBase.expandedResources.slice(firstTDIndex, endIndex);
            if (this.parent.resourceBase.renderedResources.length > 0) {
                this.updateContent(resWrap, conWrap, eventWrap, this.parent.resourceBase.renderedResources);
            }
        }
    }
    renderEvents() {
        this.setTabIndex();
        const dynamicData = this.triggerScrollEvent(events.virtualScrollStop);
        if (this.parent.activeViewOptions && this.parent.activeViewOptions.enableLazyLoading && this.parent.crudModule) {
            if (dynamicData.length > 0) {
                this.parent.crudModule.refreshProcessedData(true, dynamicData);
                this.parent.hideSpinner();
                return;
            }
            this.parent.crudModule.refreshDataManager();
            return;
        }
        if (this.parent.crudModule) {
            this.parent.crudModule.refreshProcessedData(true);
        }
        if (this.parent.currentView !== 'Month') {
            this.parent.notify(events.contentReady, {});
        }
        this.parent.hideSpinner();
    }
    virtualScrolling() {
        if (this.parent.quickPopup) {
            this.parent.quickPopup.quickPopupHide();
            this.parent.quickPopup.morePopup.hide();
        }
        const conWrap = this.parent.element.querySelector('.' + cls.CONTENT_WRAP_CLASS);
        if (this.isHorizontalScroll) {
            this.horizontalScrolling(conWrap);
        }
        else {
            const resWrap = this.parent.element.querySelector('.' + cls.RESOURCE_COLUMN_WRAP_CLASS);
            const eventWrap = this.parent.element.querySelector('.' + cls.EVENT_TABLE_CLASS);
            const timeIndicator = this.parent.element.querySelector('.' + cls.CURRENT_TIMELINE_CLASS);
            const conTable = this.parent.element.querySelector('.' + cls.CONTENT_TABLE_CLASS);
            if (!this.parent.rowAutoHeight) {
                addClass([conWrap, resWrap], 'e-transition');
            }
            this.renderedLength = resWrap.querySelector('tbody').children.length;
            const firstTDIndex = parseInt(resWrap.querySelector('tbody td').getAttribute('data-group-index'), 10);
            const scrollHeight = this.parent.rowAutoHeight ?
                (conTable.offsetHeight - conWrap.offsetHeight) : this.bufferCount * this.itemSize;
            let resCollection = [];
            this.existingDataCollection = this.parent.resourceBase.renderedResources;
            if ((conWrap.scrollTop) - this.translateY < 0) {
                resCollection = this.upScroll(conWrap, firstTDIndex);
            }
            else if (conWrap.scrollTop - this.translateY > scrollHeight) {
                resCollection = this.downScroll(conWrap, firstTDIndex);
            }
            if (!isNullOrUndefined(resCollection) && resCollection.length > 0) {
                this.triggerScrollEvent(events.virtualScrollStart);
                const selectedEle = this.parent.getSelectedCells();
                this.focusedEle = selectedEle[selectedEle.length - 1] || this.focusedEle;
                this.updateContent(resWrap, conWrap, eventWrap, resCollection);
                this.setTranslate(resWrap, conWrap, eventWrap, timeIndicator);
                if (this.parent.dragAndDropModule && this.parent.dragAndDropModule.actionObj.action === 'drag') {
                    this.parent.dragAndDropModule.navigationWrapper();
                }
                window.clearTimeout(this.timeValue);
                this.timeValue = window.setTimeout(() => { this.renderEvents(); }, 250);
            }
        }
    }
    horizontalScrolling(conWrap) {
        let resCollection = [];
        const scrollWidth = this.bufferCount * this.itemSize;
        if (Math.abs(conWrap.scrollLeft) - Math.abs(this.translateY) < 0) {
            resCollection = this.leftScroll(conWrap);
        }
        else if (Math.abs(conWrap.scrollLeft) - Math.abs(this.translateY) > scrollWidth) {
            resCollection = this.rightScroll(conWrap);
        }
        if (!isNullOrUndefined(resCollection) && resCollection.length > 0) {
            if (this.parent.resourceBase.expandedResources.length !== resCollection.length ||
                this.parent.resourceBase.expandedResources[0] !== resCollection[0] ||
                this.parent.resourceBase.expandedResources[this.parent.resourceBase.expandedResources.length - 1] !==
                    resCollection[resCollection.length - 1]) {
                this.triggerScrollEvent(events.virtualScrollStart);
                const colLevels = this.parent.activeView.colLevels.slice(0);
                this.updateHorizontalContent(conWrap, resCollection);
                setStyleAttribute(conWrap.querySelector('table'), { transform: `translateX(${this.translateY}px)` });
                this.parent.activeView.colLevels = colLevels;
                if (this.parent.dragAndDropModule && this.parent.dragAndDropModule.actionObj.action === 'drag') {
                    this.parent.dragAndDropModule.navigationWrapper();
                }
            }
            window.clearTimeout(this.timeValue);
            this.timeValue = window.setTimeout(() => { this.renderEvents(); }, 250);
        }
    }
    triggerScrollEvent(action) {
        let dynamicData = [];
        if (!this.parent.activeView) {
            return dynamicData;
        }
        const eventArgs = {
            startDate: this.parent.activeView.startDate(),
            endDate: this.parent.activeView.endDate(),
            startIndex: this.parent.resourceBase.renderedResources[0].groupIndex,
            endIndex: this.parent.resourceBase.renderedResources[this.parent.resourceBase.renderedResources.length - 1].groupIndex,
            resourceData: this.parent.resourceBase.renderedResources.map((x) => x.resourceData),
            name: action
        };
        this.parent.trigger(action, eventArgs, (args) => {
            if (action === events.virtualScrollStart) {
                this.parent.showSpinner();
            }
            else if (action === events.virtualScrollStop && !isNullOrUndefined(args.eventData) && args.eventData.length > 0) {
                dynamicData = args.eventData;
            }
        });
        return dynamicData;
    }
    upScroll(conWrap, firstTDIndex) {
        let index = 0;
        index = (~~(conWrap.scrollTop / this.itemSize) + Math.ceil(conWrap.clientHeight / this.itemSize)) - this.renderedLength;
        if (this.parent.rowAutoHeight) {
            index = (index > firstTDIndex) ? firstTDIndex - this.bufferCount : index;
        }
        index = (index > 0) ? index : 0;
        const prevSetCollection = this.getBufferCollection(index, index + this.renderedLength);
        this.parent.resourceBase.renderedResources = prevSetCollection;
        if (firstTDIndex === 0) {
            this.translateY = conWrap.scrollTop;
        }
        else {
            let height = (this.parent.rowAutoHeight) ? this.averageRowHeight : this.itemSize;
            height = (height > 0) ? height : this.itemSize;
            this.translateY = (conWrap.scrollTop - (this.bufferCount * height) > 0) ?
                conWrap.scrollTop - (this.bufferCount * height) : 0;
        }
        return prevSetCollection;
    }
    downScroll(conWrap, firstTDIndex) {
        const lastResource = this.parent.resourceBase.
            renderedResources[this.parent.resourceBase.renderedResources.length - 1].groupIndex;
        const lastResourceIndex = this.parent.resourceBase.expandedResources[this.parent.resourceBase.expandedResources.length - 1].groupIndex;
        if (lastResource === lastResourceIndex) {
            return null;
        }
        let nextSetResIndex = 0;
        nextSetResIndex = ~~(conWrap.scrollTop / this.itemSize);
        if (this.parent.rowAutoHeight) {
            nextSetResIndex = ~~((conWrap.scrollTop - this.translateY) / this.averageRowHeight) + firstTDIndex;
            nextSetResIndex = (nextSetResIndex > firstTDIndex + this.bufferCount) ? nextSetResIndex : firstTDIndex + this.bufferCount;
        }
        let lastIndex = nextSetResIndex + this.renderedLength;
        lastIndex = (lastIndex > this.parent.resourceBase.expandedResources.length) ?
            nextSetResIndex + (this.parent.resourceBase.expandedResources.length - nextSetResIndex) : lastIndex;
        const nextSetCollection = this.getBufferCollection(lastIndex - this.renderedLength, lastIndex);
        this.translateY = conWrap.scrollTop;
        return nextSetCollection;
    }
    leftScroll(conWrap) {
        let index = 0;
        index = (~~(Math.abs(conWrap.scrollLeft) / this.itemSize) + Math.ceil(conWrap.clientWidth / this.itemSize)) - this.renderedLength;
        index = (index > 0) ? index : 0;
        return this.getCollection(index, index + this.renderedLength);
    }
    rightScroll(conWrap) {
        const lastLevel = this.parent.activeView.colLevels[this.parent.activeView.colLevels.length - 1];
        let nextSetIndex = 0;
        nextSetIndex = ~~(Math.abs(conWrap.scrollLeft) / this.itemSize);
        let lastIndex = nextSetIndex + this.renderedLength;
        lastIndex = (lastIndex > lastLevel.length - 1) ? lastLevel.length - 1 : lastIndex;
        return this.getCollection(lastIndex - this.renderedLength, lastIndex);
    }
    getCollection(startIndex, endIndex) {
        this.translateY = startIndex * this.itemSize;
        const lastLevel = this.getResCollection(startIndex, endIndex);
        if (this.parent.enableRtl) {
            this.translateY = -this.translateY;
        }
        return lastLevel;
    }
    getResCollection(startIndex, endIndex) {
        const lastLevel = this.parent.activeView.colLevels[this.parent.activeView.colLevels.length - 1];
        let resCollection = [];
        const index = { startIndex: 0, endIndex: 0 };
        if (this.parent.activeViewOptions.group.byDate) {
            if (lastLevel[parseInt(startIndex.toString(), 10)].date.getTime() ===
                this.parent.resourceBase.expandedResources[0].date.getTime() &&
                lastLevel[parseInt(endIndex.toString(), 10)].date.getTime() ===
                    this.parent.resourceBase.expandedResources[this.parent.resourceBase.expandedResources.length - 1].date.getTime()) {
                return this.parent.resourceBase.expandedResources;
            }
            resCollection =
                this.getByDateCollection(lastLevel[parseInt(startIndex.toString(), 10)], lastLevel[parseInt(endIndex.toString(), 10)], index);
            this.setRenderedDates(resCollection);
        }
        else {
            if (lastLevel[parseInt(startIndex.toString(), 10)].groupIndex === this.parent.resourceBase.expandedResources[0].groupIndex &&
                lastLevel[parseInt(endIndex.toString(), 10)].groupIndex ===
                    this.parent.resourceBase.expandedResources[this.parent.resourceBase.expandedResources.length - 1].groupIndex) {
                return this.parent.resourceBase.expandedResources;
            }
            resCollection =
                this.getByIdCollection(lastLevel[parseInt(startIndex.toString(), 10)], lastLevel[parseInt(endIndex.toString(), 10)], index);
        }
        if (this.parent.currentView !== 'Month') {
            this.startIndex = index.startIndex;
            resCollection = lastLevel.slice(index.startIndex, index.endIndex);
        }
        this.translateY = index.startIndex * this.itemSize;
        return resCollection;
    }
    getByDateCollection(firstItem, lastItem, index) {
        const resCollection = this.parent.activeView.colLevels[0].filter((data) => firstItem.date.getTime() <= data.date.getTime() &&
            data.date.getTime() <= lastItem.date.getTime());
        this.setStartEndIndex(this.parent.activeView.colLevels[0], resCollection[0], resCollection[resCollection.length - 1], index);
        return resCollection;
    }
    getByIdCollection(firstItem, lastItem, index) {
        const resCollection = this.parent.resourceBase.lastResourceLevel.filter((data) => firstItem.groupIndex <= data.groupIndex && data.groupIndex <= lastItem.groupIndex);
        this.parent.resourceBase.renderedResources = resCollection;
        this.setStartEndIndex(this.parent.resourceBase.lastResourceLevel, resCollection[0], resCollection[resCollection.length - 1], index);
        return resCollection;
    }
    setStartEndIndex(data, firstItem, lastItem, colIndex) {
        let index = 0;
        data.filter((data) => {
            if (firstItem === data) {
                colIndex.startIndex = index;
            }
            else if (lastItem === data) {
                colIndex.endIndex = index + data.colSpan;
            }
            index += data.colSpan;
        });
        if (firstItem === lastItem) {
            colIndex.endIndex = colIndex.startIndex + lastItem.colSpan;
        }
    }
    updateContent(resWrap, conWrap, eventWrap, resCollection) {
        const renderedLength = resWrap.querySelector('tbody').children.length;
        if (document.activeElement && document.activeElement.classList.contains(cls.RESOURCE_CELLS_CLASS)) {
            this.isResourceCell = true;
            this.parent.element.focus();
        }
        for (let i = 0; i < renderedLength; i++) {
            remove(eventWrap.querySelector('div'));
        }
        this.parent.resourceBase.renderedResources = resCollection;
        const currentGroupIndices = this.parent.activeView.getGroupIndices(resCollection);
        const previousGroupIndices = this.parent.activeView.getGroupIndices(this.existingDataCollection);
        const newGroupIndices = currentGroupIndices.filter((index) => previousGroupIndices.indexOf(index) < 0);
        const resWrapRows = Array.from(resWrap.querySelectorAll('tbody tr'));
        const conWrapRows = Array.from(conWrap.querySelectorAll('tbody tr'));
        const resWrapBody = resWrap.querySelector('tbody');
        const conWrapBody = conWrap.querySelector('tbody');
        this.removeObsoleteRows(resWrapRows, currentGroupIndices);
        this.removeObsoleteRows(conWrapRows, currentGroupIndices);
        const resourceRows = this.parent.resourceBase.getContentRows(resCollection, true);
        const contentRows = this.parent.activeView.getContentRows();
        const eventRows = this.parent.activeView.getEventRows(resCollection.length);
        for (let i = 0; i < newGroupIndices.length; i++) {
            const index = currentGroupIndices.indexOf(newGroupIndices[parseInt(i.toString(), 10)]);
            if (index === 0) {
                prepend([resourceRows[parseInt(i.toString(), 10)]], resWrapBody);
                prepend([contentRows[parseInt(i.toString(), 10)]], conWrapBody);
            }
            else if (resWrapBody && conWrapBody && resWrapBody.children[parseInt(index.toString(), 10)] &&
                conWrapBody.children[parseInt(index.toString(), 10)]) {
                resWrapBody.insertBefore(resourceRows[parseInt(i.toString(), 10)], resWrapBody.children[parseInt(index.toString(), 10)]);
                conWrapBody.insertBefore(contentRows[parseInt(i.toString(), 10)], conWrapBody.children[parseInt(index.toString(), 10)]);
            }
            else {
                append([resourceRows[parseInt(i.toString(), 10)]], resWrapBody);
                append([contentRows[parseInt(i.toString(), 10)]], conWrapBody);
            }
        }
        append(eventRows, eventWrap);
    }
    removeObsoleteRows(elements, currentGroupIndices) {
        elements.forEach((element) => {
            const groupIndex = parseInt(element.firstElementChild.getAttribute('data-group-index'), 10);
            if (currentGroupIndices.indexOf(groupIndex) < 0) {
                remove(element);
            }
        });
    }
    updateHorizontalContent(conWrap, resCollection) {
        this.existingDataCollection = this.parent.resourceBase.expandedResources;
        this.parent.resourceBase.expandedResources = resCollection;
        const selectedEle = this.parent.getSelectedCells();
        this.focusedEle = selectedEle[selectedEle.length - 1] || this.focusedEle;
        const tbody = conWrap.querySelector('tbody');
        const renderedRows = Array.from(tbody.querySelectorAll('tr'));
        if (this.parent.currentView === 'Month') {
            this.updateMonthViewContent(conWrap, resCollection);
        }
        else {
            this.updateOtherViewContent(conWrap, resCollection, renderedRows);
        }
    }
    updateMonthViewContent(conWrap, resCollection) {
        const renderedLength = conWrap.querySelectorAll(' tr').length;
        for (let i = 0; i < renderedLength; i++) {
            remove(conWrap.querySelector('tbody tr'));
        }
        if (this.parent.activeViewOptions.group.byDate) {
            this.parent.activeView.colLevels[0] = resCollection;
        }
        else {
            this.parent.activeView.colLevels[this.parent.activeView.colLevels.length - 2] = resCollection;
        }
        const contentRows = this.parent.activeView.getContentRows();
        append(contentRows, conWrap.querySelector('tbody'));
    }
    updateOtherViewContent(conWrap, resCollection, renderedRows) {
        const tbody = conWrap.querySelector('tbody');
        const colGroup = conWrap.querySelector('colgroup');
        const thead = conWrap.querySelector('thead');
        const table = conWrap.querySelector('table');
        this.parent.activeView.colLevels[this.parent.activeView.colLevels.length - 1] = resCollection;
        const newGroupIndices = new Set(resCollection.map((data) => data.groupIndex));
        renderedRows.forEach((row) => {
            const tdElements = row.querySelectorAll('td');
            tdElements.forEach((td) => {
                const groupIndex = parseInt(td.getAttribute('data-group-index'), 10);
                if (!newGroupIndices.has(groupIndex)) {
                    td.remove();
                }
            });
        });
        const col = [].slice.call(conWrap.querySelector('colgroup').children);
        for (let i = 0; i < col.length; i++) {
            remove(col[parseInt(i.toString(), 10)]);
        }
        resCollection.forEach(() => colGroup.appendChild(createElement('col')));
        const tHead = [].slice.call(conWrap.querySelector('thead').children);
        for (let i = 0; i < tHead.length; i++) {
            remove(tHead[parseInt(i.toString(), 10)]);
        }
        thead.appendChild(this.parent.eventBase.createEventWrapper('', this.startIndex > 0 ? this.startIndex : 0));
        if (this.parent.activeViewOptions.timeScale.enable) {
            thead.appendChild(this.parent.eventBase.createEventWrapper('timeIndicator'));
        }
        prepend([thead], table);
        const contentRows = this.parent.activeView.getContentRows();
        this.mergeNewTdData(tbody, contentRows);
    }
    mergeNewTdData(tbody, contentRows) {
        const existingRows = Array.from(tbody.querySelectorAll('tr'));
        existingRows.forEach((existingRow, rowIndex) => {
            if (rowIndex < contentRows.length) {
                const newRow = contentRows[parseInt(rowIndex.toString(), 10)];
                const existingTds = Array.from(existingRow.querySelectorAll('td'));
                const newTds = Array.from(newRow.querySelectorAll('td'));
                newTds.forEach((newTd) => {
                    const newGroupIndex = parseInt(newTd.getAttribute('data-group-index').toString(), 10);
                    let inserted = false;
                    for (const existingTd of existingTds) {
                        const existingGroupIndex = parseInt(existingTd.getAttribute('data-group-index').toString(), 10);
                        if (newGroupIndex < existingGroupIndex) {
                            existingRow.insertBefore(newTd, existingTd);
                            inserted = true;
                            break;
                        }
                    }
                    if (!inserted) {
                        existingRow.appendChild(newTd);
                    }
                });
            }
        });
    }
    getBufferCollection(startIndex, endIndex) {
        return this.parent.resourceBase.expandedResources.slice(startIndex, endIndex);
    }
    setTranslate(resWrap, conWrap, eventWrap, timeIndicator) {
        setStyleAttribute(resWrap.querySelector('table'), { transform: `translateY(${this.translateY}px)` });
        setStyleAttribute(conWrap.querySelector('table'), { transform: `translateY(${this.translateY}px)` });
        setStyleAttribute(eventWrap, { transform: `translateY(${this.translateY}px)` });
        if (!isNullOrUndefined(timeIndicator)) {
            setStyleAttribute(timeIndicator, { transform: `translateY(${this.translateY}px)` });
        }
    }
    updateFocusedWorkCell() {
        if (this.focusedEle) {
            const date = parseInt(this.focusedEle.getAttribute('data-date'), 10);
            const groupIndex = parseInt(this.focusedEle.getAttribute('data-group-index'), 10);
            const ele = this.parent.element.querySelector(`.${cls.WORK_CELLS_CLASS}[data-date="${date}"][data-group-index="${groupIndex}"]`);
            if (ele) {
                this.parent.addSelectedClass([ele], ele, true);
            }
            this.focusedEle = null;
        }
    }
    setRenderedDates(resCollection) {
        if (this.parent.currentView !== 'Month') {
            const dateCol = resCollection.map((x) => x.date);
            this.parent.resourceBase.renderedResources.forEach((x) => x.renderDates = dateCol);
        }
        else {
            const dateCol = resCollection.map((x) => x.date.getDay());
            const renderDates = this.parent.activeView.renderDates.filter((x) => dateCol.indexOf(x.getDay()) >= 0);
            this.parent.resourceBase.renderedResources.forEach((x) => x.renderDates = renderDates);
        }
    }
    setTabIndex() {
        const resColWrap = this.parent.element.querySelector('.' + cls.RESOURCE_COLUMN_WRAP_CLASS);
        const resCells = [].slice.call(this.parent.element.querySelectorAll('.' + cls.RESOURCE_CELLS_CLASS));
        if (resCells && resColWrap) {
            resCells.forEach((element) => {
                if (element.getBoundingClientRect().top >= resColWrap.getBoundingClientRect().top) {
                    element.setAttribute('tabindex', '0');
                }
            });
        }
        const focusResCell = this.parent.element.querySelector(`.${cls.RESOURCE_CELLS_CLASS}[tabindex="${0}"]`);
        if (this.isResourceCell && focusResCell) {
            focusResCell.focus();
            this.isResourceCell = false;
        }
    }
    destroy() {
        this.removeEventListener();
        this.focusedEle = null;
    }
}
